import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../elements/Sidebar";
import { IconCard } from "../cards/IconCard";

import { ReactComponent as UserIcon } from "../../resources/icons/user.svg";
import { ReactComponent as AssignorIcon } from "../../resources/icons/assignor.svg";
import { ReactComponent as HelmetIcon } from "../../resources/icons/helmet.svg";
import { ReactComponent as StatsIcon } from "../../resources/icons/stats.svg";

const AdminHome: React.FC = () => {
  const navigate = useNavigate();

  const handleCardClick = (path: string) => {
    navigate(path);
  };

  return (
    <div className="flex flex-row">
      <div className="flex-1 p-6 ml-[17.5rem]">
        <h1 className="text-2xl font-bold mb-6">Admin Home</h1>

        <div className="grid grid-cols-3 gap-6">
          <button onClick={() => handleCardClick("/admin/management")}>
            <IconCard
              className="bg-white hover:shadow-lg transition text-left"
              Icon={UserIcon}
              color="#FC6A19"
              title="User management"
              text="Manage all users inside the platform"
            />
          </button>
          <button onClick={() => handleCardClick("/admin/assignors")}>
            <IconCard
              className="bg-white hover:shadow-lg transition text-left"
              Icon={AssignorIcon}
              color="#FC6A19"
              title="Assignors"
              text="Manage all assignors"
            />
          </button>
          <button onClick={() => handleCardClick("/admin/contractors")}>
            <IconCard
              Icon={HelmetIcon}
              color="#FC6A19"
              className="bg-white hover:shadow-lg transition text-left"
              title="Contractors"
              text="Manage all contractors"
            />
          </button>
          <button onClick={() => handleCardClick("/admin/statistics")}>
            <IconCard
              className="bg-white hover:shadow-lg transition text-left"
              Icon={StatsIcon}
              color="#FC6A19"
              title="Statistics"
              text="Platform statistics"
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminHome;
